/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function() {  
  if(window.location.hash === '#opencartdrawer') {
      document.getElementById('mini-cart').open = true;
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }
  $(".iwt-img-slider").slick({
    dots: false,
    infinite: false,
    arrows:true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $(".ts-slider").slick({
    dots: true,
    infinite: true,
    arrows:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '25%',
    responsive: [
      {
        breakpoint: 740,
        settings: {
          centerPadding: '10%',
        }
      }
    ]
  });

  // $(".twis-row").slick({
  //   dots: false,
  //   infinite: false,
  //   arrows:false,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 740,
  //       settings: {
  //         slidesToShow: 1,
  //       }
  //     }
  //   ]
  // });

  $('.marquee-stripe_row').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  // $('.product-list__inner--scroller').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   mobileFirst: true,
  //   arrows: true,
  //   dots: false,
  //   prevArrow: `<button class="product-list__arrow prev-next-button prev-next-button--prev">
  //                   <span class="visually-hidden">Previous</span><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-left  icon--direction-aware " viewBox="0 0 17 14">
  //       <path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2" fill="none"></path>
  //     </svg></button>`,
  //   nextArrow: `<button class="product-list__arrow prev-next-button prev-next-button--next" disabled="">
  //                   <span class="visually-hidden">Next</span><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14">
  //       <path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path>
  //     </svg></button>`,
  //   responsive: [
  //     {
  //       breakpoint: 741,
  //       settings: 'unslick'
  //     }
  //   ]
  // });

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }

  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }  

  var cartdata;

  function applydiscount(discountcode, _this){
    $.getJSON('/cart.js', function (cdata) {
      $.getJSON('/payments/config', function (data) {                      
        var main_check = {}, body_obj = {};
        body_obj.discount_code = discountcode;
        body_obj.line_items = cdata.items;
        body_obj.presentment_currency = $('body').attr('data-currency');
        main_check.checkout = body_obj;
        main_check = JSON.stringify(main_check);
        $.ajax({
          type: "POST",
          url: "/wallets/checkouts/",
          dataType: 'json',
          async: false,
          data: main_check,
          headers: {
            "Content-Type": "application/json",
            "authorization": "Basic " + btoa(data.paymentInstruments.accessToken),
            "cache-control": "no-cache",
            "pragma": "no-cache"
          },
          credentials: "include",
          error: function (response){
            console.log('response',response);  
              $('.discount-code-apply-wrapper').find('.success-msg').hide();
              $('.err-msg').hide();
              if(response.responseJSON.errors.discount_code){
                if(response.responseJSON.errors.discount_code[0].code == "discount_not_found"){
                 $('.err-msg').show().html('This coupon code has expired.');
                }
              }else if(response.responseJSON.errors.applied_discount.code){
               $('.err-msg').show().html(response.responseJSON.errors.applied_discount.code[0].message);
              }else{
               $('.err-msg').show().html('The requirements to avail the discount have not been fulfilled.'); 
              }                  
              _this.removeAttr('disabled');                                    
              _this.removeClass('loading');                  
              setCookie('discountcode',false,-1);                     
          },
          success: function (data) {     
            console.log('data',data);  
            var free_item_code = window.themeVariables.settings.free_item_code;
            var minprice = parseInt(window.themeVariables.settings.discountmin_price) * 100;
            var free_item = window.themeVariables.settings.free_item;
            var filterproduct = cartdata.items.filter((product) => {      
              return parseInt(product['product_id']) == parseInt(free_item.id)
            });
            if(data.checkout.applied_discount.title == free_item_code && cartdata['total_price'] > minprice && data.checkout.applied_discounts.length == 0 && filterproduct.length == 0){                          
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: { 
                  id: free_item.variants[0].id, 
                  quantity: 1,
                  properties: {
                    _hasfreeitem: "yes"
                  }
                },
                dataType: "json",
                error: function (e, i, s) {
                  var n = $.parseJSON(e.responseText);          
                }
              }).done(function (e) {
                $('#success_msg_free_freebie,.custom-popup-overlay').addClass('active');
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
                $.getJSON('/cart.js', function(cart){
                  cartdata = cart;    
                  $('.discount-code-apply-wrapper').find('.discount-code').val(free_item_code);
                  $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');
                });
                
                setTimeout(function(){
                  $('#success_msg_free_freebie,.custom-popup-overlay').removeClass('active');
                },3000);
                
              });            
            }else{
              if(data.checkout.applied_discounts.length > 0 && data.checkout.applied_discount.applicable){ 
                $('.err-msg').hide();                  
                $('[action="/cart"]').prepend('<input class="form_discount" type="hidden" name="discount" value="'+ data.checkout.discount_code +'">');
                $(data.checkout.line_items).each(function(i,v){
                  if(data.checkout.line_items[i].applied_discounts.length == 0){
                    $('#mini-cart .line-item[data-cart-item-key="'+v.variant_id+'-'+i+'"] .line-item__discount-list').remove();
                  }
                  if(data.checkout.line_items[i].discount_allocations.length > 0){
                    var linetotaldiscount = 0.00;
                    $(data.checkout.line_items[i].discount_allocations).each(function(i,e){
                      linetotaldiscount += parseFloat(e.amount);
                    });
                    var final_price = data.checkout.line_items[i].line_price - linetotaldiscount;
                    final_price = final_price * 100;
                    var saleprice = final_price / 100;
                    var regularprice = data.checkout.line_items[i].line_price;
                    // console.log('saleprice',saleprice);
                    // console.log('regularprice',regularprice);
                    var percentoff = (regularprice - saleprice) * 100 / regularprice;
                    // console.log('Percent Off:', percentoff)
                    var percentoffFormatted = Math.round(percentoff) + '%';
                    var pricehtml = `<span class="price price--highlight">
                      <span class="visually-hidden">Sale price</span>${formatMoney(final_price, currencyFormat)}</span><span class="price price--compare">
                      <span class="visually-hidden">Regular price</span>${formatMoney(data.checkout.line_items[i].line_price, currencyFormat)}<span class="label label--highlight">${percentoffFormatted}</span>
                    </span>`;
                    // console.log('sdfd',v.variant_id+'-'+i);
                    if(Math.round(percentoff) > 0){
                     $('#mini-cart .line-item[data-cart-item-key="'+v.variant_id+'-'+i+'"] .price-list').html(pricehtml); 
                    }                    
                  }
                });
                $('.discount-price-wrapper').show();
                $('.discount-price-wrapper .sub-total .price').html(formatMoney(data.checkout.total_line_items_price, currencyFormat));
                $('.discount-price-wrapper .discount-price .price').html('- '+ formatMoney(data.checkout.total_line_level_discount, currencyFormat));
                $('.discount-price-wrapper .total-price .price').html(formatMoney(data.checkout.total_price, currencyFormat));
                $('#mini-cart .btn-cart-totlprice').html(formatMoney(data.checkout.total_price, currencyFormat));
                var html = 'Your discounted code *'+ data.checkout.discount_code +'* is successfully applied!';                                    
                $('.discount-code-apply-wrapper .success-msg').show().html(html);                  
                _this.attr('id','remove_code_btn').find('span').text('Remove discount');
                _this.removeAttr('disabled');
                _this.removeClass('loading');
                setCookie('discountcode',data.checkout.discount_code,100000);
              }else{
                // console.log(data);
                $('.discount-code-apply-wrapper').find('.success-msg').hide();
                $('.discount-price-wrapper').hide();
                $('.err-msg').hide();
                $('.err-msg').show().html('The requirements to avail the discount have not been fulfilled.');
                _this.removeAttr('disabled');                                    
                _this.removeClass('loading');                  
                setCookie('discountcode',false,-1);                   
              }   
            }
                        
          }
        });
     }); 
  });
  }

  function applied_code(discountCodeValue, _this, sectionId){
    var existingDiscountsValue = existingDiscounts();
    if (existingDiscountsValue.includes(discountCodeValue)) return;
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          discount: [...existingDiscountsValue, discountCodeValue].join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      if (data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })
      ) {
        $(_this).removeAttr('disabled');                                    
        $(_this).removeClass('loading');
        $('.cart-coupon_offer-input').append(`<div id="applied_code_error" class="applied_code_error text--xsmall">This discount code cannot be applied to your cart</div>`);
        setTimeout(function(){
          $('#applied_code_error').remove();
        },5000);
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      // const newHtml = data.sections[sectionId];
      // const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      // $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
      // $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());
      $(_this).removeAttr('disabled');                                    
        $(_this).removeClass('loading');
    });
  }

  function existingDiscounts(){
    const discountCodes = [];
    const discountPills = $('.discount-code-apply-wrapper').find('.cart-discount__pill');
    for (const pill of discountPills) {
      if (typeof $(pill).attr('data-discount-code') === 'string') {
        discountCodes.push($(pill).attr('data-discount-code'));
      }
    }
    return discountCodes;
  }

  $('body').on('click','#discount_code_btn',function(e){
    e.preventDefault();
    var _this  = $(this);
    _this.attr('disabled','disabled');
    _this.addClass('loading');
    var sectionId = $(_this).closest('cart-drawer').attr('section');
    var discountCodeValue = _this.closest('.cart-discont-input').find('.discount-code').val();
    applied_code(discountCodeValue, _this, sectionId);


    // $('[action="/cart"]').find('.form_discount').remove();
    // var inputvalue = _this.closest('.cart-discont-input').find('.discount-code').val();
    // if(inputvalue != ''){
    //   _this.attr('disabled','disabled');
    //   applydiscount(inputvalue, _this);
    // }
  });

  $('body').on('click','[data-removecode]', function(){
    console.log('hhiiihi')
    $(this).addClass('loading');
    var sectionId = $(this).closest('cart-drawer').attr('section');
    var discountCodeValue = $(this).closest('.cart-discount__pill').attr('data-discount-code');
    var existingDiscountsValue = existingDiscounts();
    console.log(discountCodeValue)
    const index = existingDiscountsValue.indexOf(discountCodeValue);
    if (index === -1) return;

    existingDiscountsValue.splice(index, 1);
    
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ 
          discount: existingDiscountsValue.join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      // const newHtml = data.sections[sectionId];
      // const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      // console.log(parsedHtml);
      // $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
      // $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    });
  });


  // $('body').on('click','#remove_code_btn',function(e){
  //   var _this = $(this);
  //   _this.addClass('loading');
  //   var free_item = window.themeVariables.settings.free_item;    
  //   $.getJSON('/cart.js', function(cart){
  //     cartdata = cart;   
  //     var filterproduct = cartdata.items.filter((product) => {      
  //       return parseInt(product['product_id']) == parseInt(free_item.id)
  //     });
  //     if(filterproduct.length > 0){
  //       $.ajax({
  //         type: "POST",
  //         url: "/cart/change.js",
  //         data: { id: free_item.variants[0].id, quantity: 0 },
  //         dataType: "json",
  //         error: function (e, i, s) {
  //           var n = $.parseJSON(e.responseText);          
  //         }
  //       }).done(function (e) {                          
  //         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  //           bubbles: true
  //         }));   
  //         _this.attr('id','discount_code_btn').find('span').text('Apply discount');
  //         _this.removeAttr('disabled');                                    
  //         _this.removeClass('loading');                  
  //         setCookie('discountcode',false,-1);       
  //       });
  //     }else{
  //       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  //         bubbles: true
  //       }));   
  //       _this.attr('id','discount_code_btn').find('span').text('Apply discount');
  //       _this.removeAttr('disabled');                                    
  //       _this.removeClass('loading');                  
  //       setCookie('discountcode',false,-1);        
  //     }
  //   });
    
  // });

  document.addEventListener('minidrawer:update', function(event) {  
    var minprice = parseInt(window.themeVariables.settings.discountmin_price) * 100;
    var free_item = window.themeVariables.settings.free_item;    
    if(event.detail.detail){
      var cart = event.detail.detail;
      cartdata = cart;      
      var filterproduct = cartdata.items.filter((product) => {      
        return parseInt(product['product_id']) == parseInt(free_item.id)
      });
      if(cartdata['total_price'] < minprice && filterproduct.length > 0){
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { id: free_item.variants[0].id, quantity: 0 },
          dataType: "json",
          error: function (e, i, s) {
            var n = $.parseJSON(e.responseText);          
          }
        }).done(function (e) {                          
          setCookie('discountcode',false,-1);     
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));   
        });
      }else{
       if(getCookie('discountcode')){
          console.log('ininini');
          $('.discount-code-apply-wrapper').find('.discount-code').val(getCookie('discountcode'));
          $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');
        } 
      }  
      if(cartdata['total_price'] < 1 && cartdata['item_count'] > 0){
        $('[name="checkout"]').removeAttr('form').attr('type','button');
      }
    }else{
      $.getJSON('/cart.js', function(cart){
        cartdata = cart;   
        var filterproduct = cartdata.items.filter((product) => {      
          return parseInt(product['product_id']) == parseInt(free_item.id)
        });
        if(cartdata['total_price'] < minprice && filterproduct.length > 0){
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: { id: free_item.variants[0].id, quantity: 0 },
            dataType: "json",
            error: function (e, i, s) {
              var n = $.parseJSON(e.responseText);          
            }
          }).done(function (e) {                          
            setCookie('discountcode',false,-1);     
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));   
          });
        }else{
         if(getCookie('discountcode')){
            console.log('ininini');
            $('.discount-code-apply-wrapper').find('.discount-code').val(getCookie('discountcode'));
            $('.discount-code-apply-wrapper').find('#discount_code_btn').removeAttr('disabled').trigger('click');
          } 
        } 
        if(cartdata['total_price'] < 1 && cartdata['item_count'] > 0){
        $('[name="checkout"]').removeAttr('form').attr('type','button');
      }
      });
    } 

    
  });

  $(window).on('resize', function() {
    $('.product-list__inner--scroller').slick('resize');
});
});